import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhonePausedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"phone_paused"}/>
}
